<template>
  <div :class="style.content">
    <div :class="style.tabs">
      <TabPanel
        text="Настройки"
        :active="activeSection === 'Настройки'"
        @click="setActiveSection('Настройки')"
      />

      <TabPanel
        text="Контент"
        :active="activeSection === 'Контент'"
        @click="setActiveSection('Контент')"
      />
    </div>

    <div v-if="activeSection === 'Настройки'" :class="style.contentPart">
      <div :class="style.input">
        <span :class="style.heading">Доступные поля</span>

        <div :class="style.checkboxes">
          <CheckboxComponent
            text="Имя"
            :modelValue="askName"
            @update:modelValue="changeAskName"
          />

          <CheckboxComponent
            text="Телефон"
            :modelValue="askPhone"
            @update:modelValue="changeAskPhone"
          />

          <CheckboxComponent
            text="Email"
            :modelValue="askEmail"
            @update:modelValue="changeAskEmail"
          />

          <CheckboxComponent
            text="Способы связи"
            :modelValue="askConnectionList"
            @update:modelValue="changeAskConnections"
          />
        </div>
      </div>

      <div :class="style.input" v-if="askPhone">
        <div :class="style.switch">
          <span :class="style.heading">Маска телефона</span>

          <SwitchComponent
            :modelValue="isPhoneMaskEnabled"
            @update:modelValue="changePhoneMask"
          />
        </div>
      </div>

      <div :class="style.input" v-if="askPhone">
        <SelectBase
          comment="Код страны"
          :items="countryList"
          :text="countryText"
          @select="changeCountry"
        />
      </div>

      <div :class="style.input" v-if="askConnectionList">
        <span :class="style.heading">Способ связи</span>

        <div :class="style.checkboxes">
          <CheckboxComponent
            text="Телефон"
            value="phone"
            :modelValue="connectionTypes"
            @update:modelValue="changeConnectionTypes"
          />

          <CheckboxComponent
            text="WhatsApp"
            value="Whats App"
            :modelValue="connectionTypes"
            @update:modelValue="changeConnectionTypes"
          />

          <CheckboxComponent
            text="Viber"
            value="viber"
            :modelValue="connectionTypes"
            @update:modelValue="changeConnectionTypes"
          />

          <CheckboxComponent
            text="Telegram"
            value="telegram"
            :modelValue="connectionTypes"
            @update:modelValue="changeConnectionTypes"
          />
        </div>
      </div>
    </div>

    <div v-if="activeSection === 'Контент'" :class="style.contentPart">
      <div :class="style.input">
        <InputStyle
          textarea
          description="Заголовок"
          placeholder="Введите заголовок"
          size="M"
          :modelValue="headerText"
          @input="changeHeaderText"
        />
      </div>

      <div :class="style.input">
        <InputStyle
          textarea
          description="Описание"
          placeholder="Введите описание"
          size="M"
          :modelValue="paragraphText"
          @input="changeDescriptionText"
        />
      </div>

      <div :class="style.input">
        <InputStyle
          description="Текст кнопки"
          placeholder="Введите текст"
          size="M"
          :modelValue="buttonText"
          @input="changeButtonText"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import style from "./ContactsFormSettingComponent.module.scss";
import {defineComponent} from "vue";

import {
  ConnectionType,
  ContactField,
  Contacts,
  CountryName,
  questions,
  Quiz
} from "@/page/quiz/typeQuiz";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";

import TabPanel from "@/elements/UI/tabs/TabPanel/TabPanel.vue";
import SelectBase from "@/elements/UI/select/SelectBase.vue";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";
import CheckboxComponent from "@/elements/UI/input/Checkbox/CheckboxComponent.vue";
import SwitchComponent from "@/elements/UI/input/Switch/SwitchComponent.vue";

type ContactConnectionItem = {
  type?: string;
  value?: CheckboxValue;
  name?: string;
  key?: string;
  text?: string;
  bool?: boolean;
  [key: string]: unknown;
};

type ContactFieldItem = {
  bool: boolean;
  [key: string]: unknown;
};

export default defineComponent({
  name: "ContactsFormSettingComponent",

  components: {
    SwitchComponent,
    CheckboxComponent,
    InputStyle,
    SelectBase,
    TabPanel
  },

  emits: ["closePanel"],

  data() {
    return {
      style,
      modifyQuiz,
      activeSection: "Настройки" as SelectedPanel,

      countryList: [
        {
          text: "Россия (+7)",
          value: "Россия (+7)",
          variant: "tab"
        },
        {
          text: "Казахстан (+7)",
          value: "Казахстан (+7)",
          variant: "tab"
        }
      ] as SelectItem[]
    };
  },

  methods: {
    setActiveSection(name: SelectedPanel): void {
      this.activeSection = name;
    },

    changeHeaderText(event: Event): void {
      if (this.contactsQuestionIndex === -1) {
        return;
      }

      const target = event.target as HTMLInputElement | null;

      if (!target) {
        return;
      }

      if (this.mobileVersion) {
        const headerMobile = this.modifyQuiz("get", "", [
          "questions",
          this.contactsQuestionIndex,
          "contacts",
          "headerMobile"
        ]);

        const nextHeaderMobile =
          headerMobile &&
          typeof headerMobile === "object" &&
          !Array.isArray(headerMobile)
            ? {
                ...headerMobile,
                placeholder: target.value
              }
            : {
                placeholder: target.value
              };

        this.modifyQuiz("set", nextHeaderMobile, [
          "questions",
          this.contactsQuestionIndex,
          "contacts",
          "headerMobile"
        ]);

        return;
      }

      this.quiz.questions[this.selectedQuestion].contacts = {
        ...this.contactsObject,
        header: target.value
      };
    },

    changeDescriptionText(event: Event): void {
      if (this.contactsQuestionIndex === -1) {
        return;
      }

      const target = event.target as HTMLInputElement | null;

      if (!target) {
        return;
      }

      if (this.mobileVersion) {
        const paragraphMobile = this.modifyQuiz("get", "", [
          "questions",
          this.contactsQuestionIndex,
          "contacts",
          "paragraphMobile"
        ]);

        const nextParagraphMobile =
          paragraphMobile &&
          typeof paragraphMobile === "object" &&
          !Array.isArray(paragraphMobile)
            ? {
                ...paragraphMobile,
                placeholder: target.value
              }
            : {
                placeholder: target.value
              };

        this.modifyQuiz("set", nextParagraphMobile, [
          "questions",
          this.contactsQuestionIndex,
          "contacts",
          "paragraphMobile"
        ]);

        return;
      }

      this.quiz.questions[this.selectedQuestion].contacts = {
        ...this.contactsObject,
        paragraph: target.value
      };
    },

    changeButtonText(event: Event): void {
      const target = event.target as HTMLInputElement | null;

      if (!target) {
        return;
      }

      this.modifyQuiz("set", target.value, ["textContactButton"]);
    },

    changeConnectionTypes(value: ConnectionType[]): void {
      if (this.contactsQuestionIndex === -1) {
        return;
      }

      const nextConnection = this.createNextConnectionList(value);

      this.modifyQuiz("set", nextConnection, [
        "questions",
        this.contactsQuestionIndex,
        "connection"
      ]);
    },

    changeAskName(value: boolean): void {
      this.setContactField("name", value);
    },

    changeAskEmail(value: boolean): void {
      this.setContactField("email", value);
    },

    changeAskConnections(value: boolean): void {
      this.setContactField("connectionList", value);
    },

    changeAskPhone(value: boolean): void {
      this.setContactField("phone", value);
    },

    changePhoneMask(value: boolean): void {
      if (this.contactsQuestionIndex === -1) {
        return;
      }

      this.modifyQuiz("set", !value, [
        "questions",
        this.contactsQuestionIndex,
        "phoneMask"
      ]);
    },

    changeCountry(payload: SelectBasePayload): void {
      if (this.contactsQuestionIndex === -1) {
        return;
      }

      const country = this.normalizeCountry(payload.value);

      const contacts = {
        ...this.contactsObject,
        country
      };

      this.setContactsObject(contacts);
    },

    setContactField(field: ContactField, value: boolean): void {
      if (this.contactsQuestionIndex === -1) {
        return;
      }

      const contacts = {
        ...this.contactsObject,
        [field]: {
          ...(this.contactsObject[field] ?? {}),
          bool: value
        }
      };

      console.log(contacts);

      this.setContactsObject(contacts);
    },

    setContactsObject(contacts: Contacts): void {
      if (this.contactsQuestionIndex === -1) {
        return;
      }

      this.modifyQuiz("set", contacts, [
        "questions",
        this.contactsQuestionIndex,
        "contacts"
      ]);
    },

    createNextConnectionList(
      selectedConnectionTypes: ConnectionType[]
    ): ContactConnectionItem[] {
      const currentConnection = this.modifyQuiz("get", "", [
        "questions",
        this.contactsQuestionIndex,
        "connection"
      ]);

      if (!Array.isArray(currentConnection)) {
        return [];
      }

      return currentConnection.map((connectionItem, connectionIndex) => {
        const fallbackConnectionType =
          this.allowedConnectionTypes[connectionIndex];

        const connectionType =
          this.getConnectionTypeFromItem(
            connectionItem as ContactConnectionItem
          ) || fallbackConnectionType;

        return {
          ...connectionItem,
          bool: selectedConnectionTypes.includes(connectionType)
        };
      });
    },

    getConnectionTypeFromItem(
      item: ContactConnectionItem
    ): ConnectionType | "" {
      const rawValue =
        item.type ?? item.value ?? item.name ?? item.key ?? item.text ?? "";

      return this.normalizeConnectionType(rawValue);
    },

    normalizeConnectionType(value: unknown): ConnectionType | "" {
      const normalizedValue = String(value)
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "")
        .replace(/-/g, "")
        .replace(/_/g, "");

      if (normalizedValue === "phone" || normalizedValue === "телефон") {
        return "phone";
      }

      if (
        normalizedValue === "whatsapp" ||
        normalizedValue === "whatsup" ||
        normalizedValue === "ватсап" ||
        normalizedValue === "вацап"
      ) {
        return "Whats App";
      }

      if (normalizedValue === "viber" || normalizedValue === "вайбер") {
        return "viber";
      }

      if (
        normalizedValue === "telegram" ||
        normalizedValue === "телеграм" ||
        normalizedValue === "tg"
      ) {
        return "telegram";
      }

      return "";
    },

    normalizeContactField(
      value: unknown,
      defaultValue: boolean
    ): ContactFieldItem {
      if (value && typeof value === "object" && !Array.isArray(value)) {
        const field = value as ContactFieldItem;

        return {
          ...field,
          bool: typeof field.bool === "boolean" ? field.bool : defaultValue
        };
      }

      if (typeof value === "boolean") {
        return {
          bool: value
        };
      }

      return {
        bool: defaultValue
      };
    },

    normalizeCountry(value: unknown): CountryName {
      if (
        value === "Казахстан" ||
        value === "Казахстан (+7)" ||
        value === "kz" ||
        value === "KZ"
      ) {
        return "Казахстан (+7)";
      }

      return "Россия (+7)";
    }
  },

  computed: {
    quiz(): Quiz {
      return this.$quizStore.getQuiz;
    },

    mobileVersion(): boolean {
      return this.$quizStore.getSelectedVersion === "Мобильная";
    },

    questions(): questions[] {
      this.quiz;

      const value = this.modifyQuiz("get", "", ["questions"]);

      return Array.isArray(value) ? value : [];
    },

    contactsQuestionIndex(): number {
      if (this.selectedQuestion !== -1) {
        const selectedQuestion = this.modifyQuiz("get", "", [
          "questions",
          this.selectedQuestion
        ]);

        if (
          selectedQuestion &&
          typeof selectedQuestion === "object" &&
          !Array.isArray(selectedQuestion)
        ) {
          const question = selectedQuestion as questions;

          if (question?.type === "contacts" || question?.contacts) {
            return this.selectedQuestion;
          }
        }
      }

      const contactsIndex = this.questions.findIndex((question) => {
        return question?.type === "contacts" || Boolean(question?.contacts);
      });

      if (contactsIndex !== -1) {
        return contactsIndex;
      }

      if (this.questions.length >= 2) {
        return this.questions.length - 2;
      }

      return -1;
    },

    contactsQuestion(): questions | null {
      if (this.contactsQuestionIndex === -1) {
        return null;
      }

      const question = this.modifyQuiz("get", "", [
        "questions",
        this.contactsQuestionIndex
      ]);

      if (
        question &&
        typeof question === "object" &&
        !Array.isArray(question)
      ) {
        return question as questions;
      }

      return null;
    },

    contactsObject(): Contacts {
      const contacts = this.modifyQuiz("get", "", [
        "questions",
        this.contactsQuestionIndex,
        "contacts"
      ]);

      if (
        contacts &&
        typeof contacts === "object" &&
        !Array.isArray(contacts)
      ) {
        return {
          ...contacts,
          name: this.normalizeContactField(contacts.name, true),
          email: this.normalizeContactField(contacts.email, true),
          connectionList: this.normalizeContactField(
            contacts.connectionList,
            true
          ),
          phone: this.normalizeContactField(contacts.phone, true),
          country: this.normalizeCountry(contacts.country),
          header: typeof contacts.header === "string" ? contacts.header : "",
          paragraph:
            typeof contacts.paragraph === "string" ? contacts.paragraph : "",
          headerMobile:
            contacts.headerMobile &&
            typeof contacts.headerMobile === "object" &&
            !Array.isArray(contacts.headerMobile)
              ? contacts.headerMobile
              : {
                  placeholder: ""
                },
          paragraphMobile:
            contacts.paragraphMobile &&
            typeof contacts.paragraphMobile === "object" &&
            !Array.isArray(contacts.paragraphMobile)
              ? contacts.paragraphMobile
              : {
                  placeholder: ""
                }
        };
      }

      return {
        name: {
          bool: true
        },
        email: {
          bool: true
        },
        connectionList: {
          bool: true
        },
        phone: {
          bool: true
        },
        country: "Россия (+7)",
        header: "",
        paragraph: "",
        headerMobile: {
          placeholder: ""
        },
        paragraphMobile: {
          placeholder: ""
        }
      };
    },

    allowedConnectionTypes(): ConnectionType[] {
      return ["phone", "Whats App", "viber", "telegram"];
    },

    headerText(): string {
      if (this.contactsQuestionIndex === -1) {
        return "";
      }

      if (this.mobileVersion) {
        const value = this.modifyQuiz("get", "", [
          "questions",
          this.contactsQuestionIndex,
          "contacts",
          "headerMobile",
          "placeholder"
        ]);

        return typeof value === "string" ? value : "";
      }

      // const value = this.modifyQuiz("get", "", [
      //   "questions",
      //   this.contactsQuestionIndex,
      //   "contacts",
      //   "header"
      // ]);

      const value = this.quiz.questions[this.selectedQuestion].contacts.header;

      return typeof value === "string" ? value : "";
    },

    paragraphText(): string {
      if (this.contactsQuestionIndex === -1) {
        return "";
      }

      if (this.mobileVersion) {
        const value = this.modifyQuiz("get", "", [
          "questions",
          this.contactsQuestionIndex,
          "contacts",
          "paragraphMobile",
          "placeholder"
        ]);

        return typeof value === "string" ? value : "";
      }

      const value =
        this.quiz.questions[this.selectedQuestion].contacts.paragraph;

      return typeof value === "string" ? value : "";
    },

    buttonText(): string {
      const value = this.modifyQuiz("get", "", ["textContactButton"]);

      if (typeof value === "string") {
        return value;
      }

      return "";
    },

    connectionTypes(): ConnectionType[] {
      const connection = this.modifyQuiz("get", "", [
        "questions",
        this.contactsQuestionIndex,
        "connection"
      ]);

      if (!Array.isArray(connection)) {
        return [];
      }

      const result: ConnectionType[] = [];

      connection.forEach((item: unknown, connectionIndex: number) => {
        if (!item || typeof item !== "object" || Array.isArray(item)) {
          return;
        }

        const connectionItem = item as ContactConnectionItem;

        if (connectionItem.bool !== true) {
          return;
        }

        const fallbackConnectionType =
          this.allowedConnectionTypes[connectionIndex];

        const connectionType =
          this.getConnectionTypeFromItem(connectionItem) ||
          fallbackConnectionType;

        if (!connectionType) {
          return;
        }

        result.push(connectionType);
      });

      return result;
    },

    askName(): boolean {
      return this.contactsObject?.name?.bool || false;
    },

    askEmail(): boolean {
      return this.contactsObject?.email?.bool || false;
    },

    askPhone(): boolean {
      return this.contactsObject?.phone?.bool || false;
    },

    askConnectionList(): boolean {
      return this.contactsObject?.connectionList?.bool || false;
    },

    phoneMask(): boolean {
      const value = this.modifyQuiz("get", "", [
        "questions",
        this.contactsQuestionIndex,
        "phoneMask"
      ]);

      if (typeof value === "boolean") {
        return value;
      }

      return false;
    },

    isPhoneMaskEnabled(): boolean {
      return !this.phoneMask;
    },

    country(): CountryName {
      return this.contactsObject?.country || "Россия (+7)";
    },

    countryText(): string {
      return this.country;
    },

    selectedQuestion(): number {
      const selectedQuestion = Number(this.$quizStore.getSelectedQuestion);

      if (!Number.isInteger(selectedQuestion)) {
        return -1;
      }

      return selectedQuestion;
    }
  },

  watch: {
    mobileVersion() {
      this.$emit("closePanel");
    }
  }
});
</script>
